import { post, get } from '@integec/fetch-task'

export const getCoopMisoMapping = targetInfo =>
  get(targetInfo, 'coop/coop-miso-mapping')

export const postCoopMisoMapping = targetInfo => data =>
  post(targetInfo, 'coop/coop-miso-mapping')(data)

export const deleteCoopMisoMapping = targetInfo => data =>
  post(targetInfo, 'coop/coop-miso-mapping/delete')(data)
